import { register } from '@forter/core';
import { FcPopover } from './FcPopover.js';

register(FcPopover);
